<div class="wrap">
  <!-- <div
    class="scanner-container"
    [appHidden]="(scannerService.hasCameraPermission | async) === false"
  > -->
  <!-- <div class="overlay"> -->
  <!-- <div class="camera-container"> -->
  <zxing-scanner
    #zxingScanner
    *ngIf="scannerService.isRan"
    class="scanner"
    [formats]="scannerService.supportedFormats"
    [appHidden]="(scannerService.hasCameraPermission | async) === null"
    [enable]="scannerService.isRan"
    [delayBetweenScanSuccess]="1000"
    [previewFitMode]="'cover'"
    (camerasNotFound)="scannerService.errorEmitted.next($event)"
    (scanSuccess)="scannerService.valueScanned.next($event)"
    (scanError)="scannerService.errorEmitted.next($event)"
    (permissionResponse)="scannerService.setPermission($event)"
    [autofocusEnabled]="true"
    (camerasFound)="scannerService.camerasFound.next($event)"
    [device]="(scannerService.selectedCameraDevice$ | async)!"
  ></zxing-scanner>
  <div *ngIf="scannerService.isRan" class="moving-line"></div>
  <!-- </div> -->
  <!-- </div> -->
  <!-- </div> -->
</div>
